import api from './api';

/** Normalize company_info API payloads whether nested or flat. */
export const normalizeCompanyInfo = (payload) => {
    if (!payload || typeof payload !== 'object') return null;

    // { status/success, data: { companyName, ... } }
    if (
        payload.data &&
        typeof payload.data === 'object' &&
        (payload.data.companyName != null ||
            payload.data.companyNameEn != null ||
            payload.data.id != null ||
            payload.data.contractHeaderBase64 != null ||
            payload.data.receiptHeaderBase64 != null ||
            payload.data.logoBase64 != null ||
            payload.data.receiptConfig != null ||
            payload.data.contractConfig != null)
    ) {
        const d = { ...payload.data };
        if (typeof d.receiptConfig === 'string') {
            try { d.receiptConfig = JSON.parse(d.receiptConfig); } catch (e) {}
        }
        if (typeof d.contractConfig === 'string') {
            try { d.contractConfig = JSON.parse(d.contractConfig); } catch (e) {}
        }
        return d;
    }

    if (
        payload.companyName != null ||
        payload.companyNameEn != null ||
        payload.id != null ||
        payload.contractHeaderBase64 != null ||
        payload.receiptHeaderBase64 != null ||
        payload.logoBase64 != null ||
        payload.receiptConfig != null ||
        payload.contractConfig != null
    ) {
        const d = { ...payload };
        if (typeof d.receiptConfig === 'string') {
            try { d.receiptConfig = JSON.parse(d.receiptConfig); } catch (e) {}
        }
        if (typeof d.contractConfig === 'string') {
            try { d.contractConfig = JSON.parse(d.contractConfig); } catch (e) {}
        }
        return d;
    }

    return null;
};

export const getCompanyInfo = async () => {
    const response = await api.get('/company_info.php');
    const normalized = normalizeCompanyInfo(response);
    if (!normalized) {
        // Preserve previous throw/empty behavior for "not found"
        if (response?.status === 'error' || response?.message) {
            throw new Error(response.message || 'Company information not found');
        }
        throw new Error('Company information not found');
    }
    return normalized;
};

export const createCompanyInfo = async (data) => {
    const response = await api.post('/company_info.php', data);
    return response?.data ?? response;
};

export const updateCompanyInfo = async (data) => {
    const response = await api.put('/company_info.php', data);
    return response?.data ?? response;
};
